import * as React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import { CollapseContainer } from './style';

import Image from 'src/components/atoms/image';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  '&:hover': {
    backgroundColor: 'transparent',
  },
  backgroundColor: 'transparent',
}));

type Props = {
  alt?: string;
  imageUrl: string;
  label: string;
};

const paymentMethod = ({ alt, imageUrl, label }: Props) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <CollapseContainer onClick={handleExpandClick}>
        <div>{label}</div>
        <div>
          <ExpandMore expand={expanded}>
            <ExpandMoreIcon color="primary" />
          </ExpandMore>
        </div>
      </CollapseContainer>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Image alt={alt!} src={imageUrl} />
      </Collapse>
    </>
  );
};

export default paymentMethod;
